<template>
  <div class="fixed-actions">
    <!-- QQ咨询按钮 -->
    <el-tooltip
        :content="isMobile ? '咨询' : '在线课程咨询'"
        placement="left"
        :show-arrow="!isMobile"
    >
      <div class="action-btn qq-btn" @click="openQQ">
        <ChatDotSquare size="24px" />
        <span v-if="!isMobile">课程咨询</span>
      </div>
    </el-tooltip>

    <!-- 返回顶部按钮 -->
    <el-tooltip
        :content="isMobile ? '顶部' : '返回页面顶部'"
        placement="left"
        :show-arrow="!isMobile"
    >
      <div
          class="action-btn top-btn"
          @click="backToTop"
          :class="{ 'visible': showBackTop }"
      >
        <ArrowUp size="24px"/>
        <span v-if="!isMobile">返回顶部</span>
      </div>
    </el-tooltip>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { ElMessageBox } from 'element-plus'
import { ArrowUp, ChatDotSquare } from '@element-plus/icons-vue'

// 响应式状态
const isMobile = ref(false)
const showBackTop = ref(false)

// 检查屏幕尺寸
const checkScreenSize = () => {
  isMobile.value = window.innerWidth < 768
}

// 监听滚动事件
const handleScroll = () => {
  showBackTop.value = window.scrollY > 300
}

// 返回顶部功能
const backToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

// 微信咨询图片导入（实际使用时替换为真实路径）
import wechatQrcode from '../assets/images/wechat-qrcode.png'

// 打开QQ咨询弹窗
const openQQ = () => {
  ElMessageBox.alert(
      '<div style="text-align: center; padding: 20px 0;">\n' +
      '        <div>\n' +
      '          <p style="margin-bottom: 8px; font-weight: bold;">扫码添加微信咨询</p>\n' +
      '          <img src="' + wechatQrcode + '" alt="微信咨询二维码" style="width: 160px; height: 160px; margin: 0 auto; display: block; border: 1px solid #eee; padding: 5px;"/>\n' +
      '        </div>\n' +
      '      </div>',
      '课程咨询',
      {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        center: true,
        callback: () => {},
      }
  )
}

// 初始化和清理
onMounted(() => {
  checkScreenSize()
  window.addEventListener('resize', checkScreenSize)
  window.addEventListener('scroll', handleScroll, { passive: true })

  // 初始检查一次滚动位置
  handleScroll()
})

onUnmounted(() => {
  window.removeEventListener('resize', checkScreenSize)
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
.fixed-actions {
  position: fixed;
  right: 20px;
  bottom: 50px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1000;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 18px;
  width: 50px;
  height: 50px;
  padding: 0;
}

.action-btn span {
  display: none;
  font-size: 14px;
}

.action-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

/* QQ按钮样式 */
.qq-btn {
  color: #12b7f5;
}

.qq-btn:hover {
  background-color: #f0faff;
}

/* 返回顶部顶部按钮按钮样式 */
.top-btn {
  color: #ff6700;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease;
}

.top-btn.visible {
  opacity: 1;
  pointer-events: auto;
}

.top-btn:hover {
  background-color: #fff8f0;
}

/* 桌面端样式 */
@media (min-width: 768px) {
  .action-btn {
    width: auto;
    height: auto;
    flex-direction: column;
    border-radius: 4px;
    padding: 10px 8px;
  }

  .action-btn span {
    display: block;
    margin-top: 5px;
  }
}

/* 移动端样式优化 */
@media (max-width: 767px) {
  .action-btn svg {
    display: block !important;
    width: 24px !important;
    height: 24px !important;
    opacity: 1 !important;
  }

  .fixed-actions {
    right: 10px;
    bottom: 30px;
  }

  .action-btn {
    width: 44px;
    height: 44px;
  }
}
</style>
